export const CLIENT_ID = 'student';
